module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "glossary"
    }
  }, [_c('h1', [_vm._v("このサイトについて")]), _vm._v(" "), _c('h2', [_vm._v("サイトの目的")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v("日本におけるSet Danceの普及、日本語での情報提供を目的としています。\n  国内におけるSet Danceにかかわる情報はダンスという特性上、個人では得難いものです。\n  教本も英語のものがほとんどで初学者に優しくありません。\n  実際に踊った経験を踏まえながら、こうした情報を集約していくことで、日本国内におけるセットダンス文化の成熟に寄与したいです。\n  ")]), _vm._v(" "), _c('h2', [_vm._v("オフラインでの使用")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v("一度ページを開くとオフライン下でもアクセスが可能です。")]), _vm._v(" "), _c('h2', [_vm._v("情報源")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v("DanceMinder, Irish Set Dancing, 日本のCCEクラスなど")]), _vm._v(" "), _c('h2', [_vm._v("制作情報")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v("vue.js + firebase")]), _vm._v(" "), _c('h2', [_vm._v("アイルランド各州の紋章について")]), _vm._v(" "), _c('span', {
    staticClass: "md-body-2"
  }, [_vm._v("「List of Irish counties' coats of arms」 from Wikipedia CC BY-SA 3.0")]), _vm._v(" "), _c('md-divider'), _vm._v(" "), _c('span', {
    staticClass: "md-caption"
  }, [_vm._v("copyright © 2017-" + _vm._s(new Date().getFullYear()) + " Hiroshi Jo")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b51412","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 325
// module chunks = 1